window.HEADER_RENDER_SERVICE = window.HEADER_RENDER_SERVICE || {};

export const {
  bootstrapConfig,
  requiredBootstrapFeatures,
  deviceType,
  headerConfig,
  translations,
  openbetLoginUrl,
  serviceUrl,
  locale,
  domain,
} = window.HEADER_RENDER_SERVICE.__CONFIG__;
